// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/spende-fuer-die-stiftung-fuer-krebskranke-kinder-coburg-2-2/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const spendeFuerDieStiftungFuerKrebskrankeKinderCoburg22DE: PageEntry = {
  id: "post.spende-fuer-die-stiftung-fuer-krebskranke-kinder-coburg-2-2",
  locale: "de",
  slug: "spende-fuer-die-stiftung-fuer-krebskranke-kinder-coburg-2-2",
  seo: {
    title: "Seminar in Fürsteneck | Dietz GmbH",
    description: "Seminar in Fürsteneck",
  },
  type: "post",
  h1: "Seminar in Fürsteneck",
  blocks: [
    { kind: "heading", level: 2, text: "Seminar in Fürsteneck" },
    { kind: "paragraph", text: "Wie schon im vergangenen Jahr besuchte auch diesen Mai eine Abteilung unserer Azubis aus dem zweiten Lehrjahr ein Seminar auf Burg Fürsteneck. Vom 14.05. bis zum 18.05. diskutierten unsere Lehrlinge zusammen mit Kollegen anderer Firmen über Fragen wie „Wem nützt, was wir tun?“ und andere Dinge, die im normalen Betriebsalltag oft zu kurz kommen. Den Abschluss bildeten Vorträge zum Thema Elektromobilität (von Dominik Siebert und Florian Knoch) sowie eine Präsentation über Industrie 4.0 (Antonio Hanft)." },
    { kind: "paragraph", text: "Bild von links nach rechts: Holger Epp (Betriebsleiter) Andrea Dietz (Personalleiterin), Günter Kümpflein, Florian Knoch, Antonio Hanft, Dominik Siebert, Hamed Qayomi und Michael Wagner (Ausbildungsleiter)" }
  ],
};
